module.exports = __webpack_public_path__ + "static/media/stock-management.3e150ed4.svg";